module.exports = __webpack_public_path__ + "img/football_dribbling.ff21bd71.svg";